import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import Avatar from 'vue-avatar';

@Component({
  name: 'bpc-public-contact-card',
  components: {
    Avatar,
  },
})
export default class ContactCard extends Vue {
  @Prop(Object) readonly item: AnyEntity;

  onActionClicked(action, row) {
    this.$emit('action-clicked', action, row);
  }

  get contactEmail() {
    return this.item.contact_detail?.email1 || this.item.contact_detail?.email2;
  }

  get contactPhone() {
    return (
      this.item.contact_detail?.phone1 ||
      this.item.contact_detail?.phone2 ||
      this.item.contact_detail?.phone3
    );
  }

  /* Lifecycle hooks */
  // created () { }
  // mounted () { }
  // updated () { }
  // destroyed () { }
}
